import AppTopbar from "../Components/AppTopbar";
import { useTranslation } from "react-i18next";
import dbservice from "../Utility/DbConnection/dbservice.js";
import { TransformIntSQLDate } from "../Utility/Utility";

import { InputNumber } from "primereact/inputnumber";
import { Calendar } from "primereact/calendar";
import { RadioButton } from "primereact/radiobutton";
import { Toast } from "primereact/toast";
import { Dropdown } from "primereact/dropdown";

import { Button } from "primereact/button";
import React, { useEffect, useRef, useState } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";

import SearchPanelComponent from "../Components/Panels/SearchPanelComponent";
import { Image } from "primereact/image";
import dbManagerInterface from "../Utility/DbConnection/DBManagerInterface.js";
import { Panel } from "primereact/panel";

const route = "Automata/Events/";

function EventPage() {
  const type = "event";
  const toast = useRef(null);
  const { t } = useTranslation();
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [topNumber, setTopNumber] = useState(null);
  const [sampleTime, setSampleTime] = useState(null);
  const [eventMetadata, setEventMetadata] = useState(null);
  const [selectedEvents, setSelectedEvents] = useState(null);
  const [eventData, setEventData] = useState([]);
  const [selectedMachine, setSelectedMachine] = useState(null);

  const [loading, setLoading] = useState(false);
  const [isDataPresent, setIsDataPresent] = useState(false);
  const [columns, setColumns] = useState(false);

  useEffect(() => {}, []); // Dependency array is empty, so it runs only on mount

  useEffect(() => {
    setLoading(true);
    if (eventMetadata && eventMetadata.length > 0) {
      setLoading(false);
      const actualDate = new Date();
      setEndDate(actualDate);
      const actualDateMinusOneDay = new Date(
        actualDate.getTime() - 24 * 60 * 60 * 1000
      );
      setStartDate(actualDateMinusOneDay);
    }
  }, [eventMetadata]);

  const onSearchClick = () => {
    const startDateSQL = TransformIntSQLDate(startDate);
    const endDateSQL = TransformIntSQLDate(endDate);

    if (startDate > endDate) {
      console.log("Start Date is greater than End Date");
      toast.current.show({
        severity: "error",
        summary: t("error"),
        detail: t("error1"),
        life: 3000,
      });
    }
    let machineToSend;
    let eventToSend = "";

    if (selectedEvents) {
      eventToSend = selectedEvents.name;
      machineToSend = selectedEvents.machine;
    } else {
      toast.current.show({
        severity: "error",
        summary: t("error"),
        detail: t("error3"),
        life: 3000,
      });
      return;
    }

    const body = {
      Machine: machineToSend,
      Event: eventToSend,
      DateStart: startDateSQL,
      DateEnd: endDateSQL,
      Top: topNumber,
      SampleTime: sampleTime,
    };
    const client = sessionStorage.getItem("chosenClient");
    const plant = sessionStorage.getItem("chosenPlant");
    const machine = machineToSend;
    const queryParams = `Client=${client}-${plant}&Machine=${machine}`;
    dbManagerInterface.SendPostRequest(
      route + "GetEvent",
      JSON.stringify(body),
      (resData) => {
        if (!resData.success || resData.data?.length === 0) {
          toast.current.show({
            severity: "warn",
            summary: t("warning"),
            detail: t("warning1"),
            life: 3000,
          });
          setIsDataPresent(false);
          setLoading(false);
        } else {
          setEventData(resData.data);
          console.log(resData.data);
          const otherColumns = [];
          const tsColumn = []; // Array to store the TS column
          const columnNames = new Set();
          resData.data.forEach((item) => {
            Object.keys(item).forEach((key) => {
              if (!columnNames.has(key)) {
                // Check if column name already exists
                columnNames.add(key);
                const columnComponent = (
                  <Column
                    key={key}
                    field={key}
                    header={key.charAt(0).toUpperCase() + key.slice(1)}
                    sortable
                  />
                );
                if (key !== "RowNum" && key !== "SampleTime") {
                  if (key === "TS") {
                    tsColumn.push(columnComponent); // Add TS column to its own array
                  } else {
                    otherColumns.push(columnComponent); // Add other columns
                  }
                }
              }
            });
          });
          // Combine TS column with other columns, ensuring TS is first
          const combinedColumns = [...tsColumn, ...otherColumns];
          setColumns(combinedColumns);
          setIsDataPresent(true);
          setLoading(false);
        }
      },
      (error) => {
        console.error("error", error);
        setLoading(false);
      },
      toast.current,
      null,
      queryParams
    );
  };

  return (
    <div>
      <AppTopbar title={t("events")} menuCode={3} />
      <Toast ref={toast} />
      <div
        style={{
          width: "100%",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <SearchPanelComponent
          startDate={startDate}
          setStartDate={setStartDate}
          endDate={endDate}
          setEndDate={setEndDate}
          topNumber={topNumber}
          setTopNumber={setTopNumber}
          sampleTime={sampleTime}
          setSampleTime={setSampleTime}
          type={type}
          selectedMachine={selectedMachine}
          setSelectedMachine={setSelectedMachine}
          setMeasuresMetadata={setEventMetadata}
          setSelectedMeasures={setSelectedEvents}
          measuresMetadata={eventMetadata}
          selectedMeasures={selectedEvents}
          onSearchClick={onSearchClick}
          tableData={eventData}
        />

        <Panel>
          <div
            style={{
              display: isDataPresent ? "block" : "none",
              width: "100%",
              overflowX: "auto",
            }}
          >
            <DataTable
              value={eventData}
              stripedRows
              paginator
              rows={5}
              rowsPerPageOptions={[5, 10, 20, 50]}
            >
              {columns}
            </DataTable>
          </div>

          <div
            style={{
              display: loading ? "block" : "none",
            }}
          >
            <Image
              src={"/pms/loading.gif"}
              alt={"loading"}
              style={{ display: loading ? "block" : "none" }}
            ></Image>
          </div>

          <div
            style={{
              display: !isDataPresent && !loading ? "flex" : "none",
              justifyContent: "center",
              alignItems: "center",
              flexDirection: "column",
              margin: "1%",
              textAlign: "center",
            }}
          >
            <h1 style={{ marginBottom: "1rem" }}>{t("noData")}</h1>
            <Image
              src={"/pms/no_data.gif"}
              alt={"no_data"}
              style={{ maxWidth: "300px", height: "450px", width: "100%" }}
            />
          </div>
        </Panel>
      </div>
    </div>
  );
}

export default EventPage;
